import { graphql } from "generated/gql";

export const observationFieldsFragment = graphql(/* GraphQL */ `
  fragment ObservationFields on Observation {
    id
    createdAt
    updatedAt
    editedAt
    archivedAt
    body
    bodyData
    condition
    user {
      id
      email
      givenName
      familyName
      email
      avatarUrl
      initials
    }
    material {
      id
    }
    images {
      nodes {
        ...MaterialImageFields
      }
    }
  }
`);

export const createObservationDocument = graphql(/* GraphQL */ `
  mutation CreateObservation($input: CreateObservationInput!, $followUp: FollowUpInput) {
    createObservation(input: $input, followUp: $followUp) {
      success
      observation {
        ...ObservationFields
      }
    }
  }
`);

export const updateObservationDocument = graphql(/* GraphQL */ `
  mutation UpdateObservation($id: ID!, $input: UpdateObservationInput!) {
    updateObservation(id: $id, input: $input) {
      success
      observation {
        ...ObservationFields
      }
    }
  }
`);

export const archiveObservationDocument = graphql(/* GraphQL */ `
  mutation ArchiveObservation($id: ID!) {
    archiveObservation(id: $id) {
      success
      observation {
        id
        archivedAt
        updatedAt
      }
    }
  }
`);
